import { render } from "./MapSplitMatter.vue?vue&type=template&id=76969b4e&scoped=true&ts=true"
import script from "./MapSplitMatter.vue?vue&type=script&lang=ts"
export * from "./MapSplitMatter.vue?vue&type=script&lang=ts"

import "./MapSplitMatter.vue?vue&type=style&index=0&id=76969b4e&lang=scss&scoped=true"
import "./MapSplitMatter.vue?vue&type=style&index=1&id=76969b4e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76969b4e"]])

export default __exports__